import React, { useContext } from 'react'
import Modal from 'react-bootstrap/Modal'
import './RedeemPopUp.scss'
import { AppContext } from 'src/App';
import closeButton from '../../styles/images/button-close.svg';

export function RedeemPopUp(props) {
    const {translate:t} = useContext(AppContext)
    return (
        <Modal dialogClassName="modal__dialog" show={props.isOpen} className={`${props.className}`} centered>
            <Modal.Header className="modal__header p-0 d-block w-100">
                {props.headerTitle ? <div className="d-block w-100">
                    <h2 className="set-popup-title">{props.headerTitle}</h2>
                </div> : ""}
                <button className="closeicon" onClick={ props.closePopup }>
                    <img src={closeButton} alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body className="modal__body">
                {props.dialogMsg ? <h3 className="modal__body__title">{props.dialogMsg}</h3> : ""}
                {(props.subInfo) ? <div className="modal__body__content">{props.subInfo}</div> : ""}
            </Modal.Body>
            <Modal.Footer className="modal__footer">
                {(props.footerInfo) ? <div className="modal__footer__content w-100">{props.footerInfo}</div> : ""}
            </Modal.Footer>
        </Modal>
    );
};